// announcementsApiSlice.js

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ENDPOINTS } from '../../apis/endpoints';
import { apiSlice } from '../../app/api/apiSlice';

export const announcementsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchBirthdays: builder.query({
      query: () => ENDPOINTS.EMPLOYEE.BIRTHDAYS,

      transformResponse: (response) => {
        // For example, add full photo URL

        return response.map((user) => {
          const fileName = user.employeePhotoPath ? user.employeePhotoPath.split('/').pop() : null;
          const encodedFileName = fileName ? encodeURIComponent(fileName) : null;
          const fullPhotoUrl = encodedFileName
            ? `${process.env.REACT_APP_BASE_PHOTO_URL}${encodedFileName}`
            : null;

          return {
            ...user,
            employeePhotoPath: fullPhotoUrl, // replace the original path with the full URL
          };
        });
      },
      providesTags: (result) =>
        result
          ? [{ type: 'User', id: 'LIST' }, ...result.map(({ _id }) => ({ type: 'User', id: _id }))]
          : [{ type: 'User', id: 'LIST' }],
    }),
    fetchWorkAnniversary: builder.query({
      query: () => ENDPOINTS.EMPLOYEE.WORK_ANNIVERSARY,
     transformResponse: (response) => {
        // For example, add full photo URL

        return response.map((user) => {
          const fileName = user.photo ? user.photo.split('/').pop() : null;
          const encodedFileName = fileName ? encodeURIComponent(fileName) : null;
          const fullPhotoUrl = encodedFileName
            ? `${process.env.REACT_APP_BASE_PHOTO_URL}${encodedFileName}`
            : null;

          return {
            ...user,
            photo: fullPhotoUrl, // replace the original path with the full URL
          };
        });
      },
      providesTags: ['WorkAnniversary'],   
    }),
  

    fetchNewJoinees: builder.query({
      query: () => ENDPOINTS.EMPLOYEE.NEWJOINEES,
        transformResponse: (response) => {
        // For example, add full photo URL

        return response.map((user) => {
          const fileName = user.photo ? user.photo.split('/').pop() : null;
          const encodedFileName = fileName ? encodeURIComponent(fileName) : null;
          const fullPhotoUrl = encodedFileName
            ? `${process.env.REACT_APP_BASE_PHOTO_URL}${encodedFileName}`
            : null;

          return {
            ...user,
            photo: fullPhotoUrl, // replace the original path with the full URL
          };
        });
      },
      providesTags: (result) =>
        result
          ? [{ type: 'User', id: 'LIST' }, ...result.map(({ _id }) => ({ type: 'User', id: _id }))]
          : [{ type: 'User', id: 'LIST' }],
    }),
    // fetchWorkAnniversary: builder.query({
    //   query: () => ENDPOINTS.EMPLOYEE.WORK_ANNIVERSARY,
    //   providesTags: ['WorkAnniversary'],
    // }),

    fetchShabashWinners: builder.query({
      query: () => ENDPOINTS.EMPLOYEE.SHABASHWINNERS,
      providesTags: (result) =>
        result
          ? [{ type: 'Shabash', id: 'LIST' }, ...result.map(({ _id }) => ({ type: 'Shabash', id: _id }))]
          : [{ type: 'Shabash', id: 'LIST' }],
    }),

    fetchRnrWinners: builder.query({
      query: () => ENDPOINTS.RNR.GET_ALL_WINNERS,
      providesTags: (result) =>
        result
          ? [
            { type: 'Rnr', id: 'LIST' },
            ...(Array.isArray(result) ? result.map(({ _id }) => ({ type: 'Rnr', id: _id })) : []),
          ]
          : [{ type: 'Rnr', id: 'LIST' }],
    }),
  }),
});

export const {
  useFetchNewJoineesQuery,
  useFetchBirthdaysQuery,
  useFetchWorkAnniversaryQuery,
  useFetchShabashWinnersQuery,
  useFetchRnrWinnersQuery,
} = announcementsApiSlice;
